import React, { Component, Fragment }                                      from "react"
import Responsive                                                from "react-responsive"
import { observer }                                              from "mobx-react"
import { Button, Container, Dropdown, Icon, Image, Menu, Modal } from "semantic-ui-react"
import { Link, NavLink }                                         from "react-router-dom"
import CartButton                                                from "components/Cart/CartButton"
import CartTotalMinimum                                          from "components/Cart/CartTotalMinimum"
import shop                                                      from "shop/shop"
import MenuBySlug                                                from "components/Menu/MenuBySlug"
import {Col, Row} from "elemental-react16"
import languageStore               from "stores/languageStore"
import app                         from "app.controller"
import "style/header.scss"
import searchStore                 from "stores/searchStore"
// import { SearchForm }              from "components/Search/SearchBarWithOptions"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import categoryStore               from "stores/categoryStore"
import { useLocation, withRouter } from "react-router"
import Typeahead                   from "../../../../components/Typeahead/Typeahead";

// import Navigation from "../Navigation/Navigation"

@observer
export default class Header extends Component {
  
  constructor() {
    super()
    this.state = {
      list: shop.orderlist.default,
      categoryData: false,
    }
  }
  
  componentDidMount() {
    shop.events.loaded.add( this.handleLoad )
    //shop.orderlist.default.events.change.add( this.handleOrderlist )
  }
  
  handleOrderlist = ( { list } ) => {
    this.setState( {
                     list
                   } )
  }
  
  handleLoad = () => {
    this.setState( {
                     categoryData: shop.categories
                   } )
  }
  
  componentWillUnmount() {
    //shop.orderlist.default.events.change.remove( this.handleOrderlist )
    shop.events.loaded.remove( this.handleLoad )
  }
  
  render() {
    const { showMini, searchValue } = this.state
    return (
      <header className={`header ${showMini}`}>
        <Responsive maxWidth={850}>
          <div>
            {showMini && <MiniHeaderMobile/>}
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState( { showMini: false } )
              }}
              onPassed={() => {
                console.log( "scrolled" )
                this.setState( { showMini: "scrolled" } )
              }}>
              <MobileHeader/>
            </OnOffset>
          </div>
        </Responsive>
        <Responsive minWidth={851}>
          <div>
            {showMini && <MiniHeader/>}
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState( { showMini: false } )
              }}
              onPassed={() => {
                console.log( "scrolled" )
                this.setState( { showMini: "scrolled" } )
              }}>
              <DesktopHeader/>
            </OnOffset>
          </div>
        </Responsive>
      </header>
    )
  }
}

class MobileHeader extends Component {
  render() {
    const { inverted = false } = this.props
    return (
      <div className="MobileHeader ">
        <div className="pa1 ph2 ph2-ns pt3-ns pb3-ns">
          <div className="flex flex-row justify-between items-center ">
            <div className={"w-70 flex flex-row justify-start pr4 pb3 pt3"}>
              <Button className="ButtonFooter" as="div"><Icon className="IconCss" onClick={app.sidebarLeft.toggle.dispatch} name="big bars" /></Button>
              {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
              <Button className="ButtonFooter" as={Link} to={`/account/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big user circle" /></Button>}
              {((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
              <Button className="ButtonFooter" as={Link} to={`/login/?referrer=${document.location.pathname}`}><Icon className="IconCss"  name="big user circle" /></Button>}
            </div>
            
            <div className={"w-100 flex flex-row items-center justify-center"}>
              <Image as={Link} to={"/home/"} src={shop.config.logo} />
            </div>
            
            <div className={"w-70 flex flex-row justify-end items-center pr4 pb3 pt3"}>
              {/*<Search />*/}
              <Button className="ButtonFooter" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              <Button className="ButtonFooter" as={Link} to={`/checkout/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big shopping cart" /></Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const SettingsModal = ( { inverted } ) => {
  return (
    <Modal  trigger={<Button basic inverted={inverted} icon="settings"/>}>
      <Modal.Content>
        <SettingsMenu vertical/>
      </Modal.Content>
    </Modal>
  )
}


const SettingsMenu = observer(
  ( props ) => {
    const { currentLanguage } = languageStore
    return (
      <Menu secondary
            borderless
            fluid
            {...props}
            size="small">
        
        {/* LEFT SIDE MENU */}
        {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Menu.Item
          position="right"
          as={Link}
          to="/orderlist/"><Icon name={"heart"}/> {translate( "Orderlist" )}</Menu.Item>}
        
        {/* RIGHT SIDE MENU*/}
        
        {(shop.session && shop.session.handId) && <Menu.Item
          as={Link}
          to="/login/accounts/">{translate( "Clients" )}</Menu.Item>}
        {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item
          as={Link}
          to="/quickorder/"><Icon name={"shopping basket"}/>{translate( "Quickorder" )}</Menu.Item>}
        
        {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Menu.Item
          as={Link}
          to="/account/"><Icon name={"user"}/>{translate( "My Account" )}</Menu.Item>}
        {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Menu.Item
          as={Link}
          to="/logout/"><Icon name={"power off"}/>{translate( "Logout" )}</Menu.Item>}
        
        {!shop.session && <LoginLink/>}
        {shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>}
        {languageStore.available.length > 1 && <Dropdown text={currentLanguage.toUpperCase()}
                                                         pointing
                                                         className="link item">
          <Dropdown.Menu>
            {languageStore.available.map( locale => <Dropdown.Item
              key={locale}
              onClick={() => languageStore.setLanguage( locale )}>{locale}</Dropdown.Item> )}
          </Dropdown.Menu>
        </Dropdown>}
      </Menu>
    )
  }
)

function LoginLink() {
  const location = useLocation()
  return <Menu.Item
    position="right"
    as={Link}
    to={`/login?referrer=${location.pathname + location.search}`}><Icon name={"power on"}/>{translate( "Anmelden" )}</Menu.Item>
}

@observer
class DesktopHeader extends Component {
  render() {
    return (
      <div><div style={{backgroundColor: "#f1f1f1"}} ><Container className="relative ">

        <Responsive minWidth={890}>
                <div className="checkmarkBanner flex-grow-1 flex">
                <span className="letterBannerLeft flex-grow-1">
          <a>
            <img style={{ width: "25px", height: "25px", minWidth: "25px" }} src={"/checkmark.png"}></img>
          </a>
          {translate("B2B Shop")}
          </span>
          <span className="letterBannerCenter flex-grow-1">
          <a>
            <img style={{ width: "25px", height: "25px", minWidth: "25px" }} src={"/checkmark.png"}></img>
          </a>
          {translate("Beratung: 0521 - 68427")}
          </span>
          <span className="letterBannerCenter flex-grow-1">
          <a>
            <img style={{ width: "25px", height: "25px", minWidth: "25px" }} src={"/checkmark.png"}></img>
          </a>
          {translate("Merklisten")}
          </span>
          <span className="letterBannerCenter flex-grow-1">
          <a>
            <img style={{ width: "25px", height: "25px", minWidth: "25px" }} src={"/checkmark.png"}></img>
          </a>
          {translate("Rechnungskauf")}
          </span>
          <span className="letterBannerRight flex-grow-1">
          <a>
            <img style={{ width: "25px", height: "25px", minWidth: "25px" }} src={"/checkmark.png"}></img>
          </a>
          {translate("Produktanfragen")}
          </span>
        </div>
        </Responsive>

        </Container></div>
      {/*Falls Anpassung <Container className="relative"><div className="checkmarkBanner" >
        <table>
          <colgroup>
            <col width="20%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="20%"/>
          </colgroup>
          <tbody>
            <tr>
              <td><Icon className="iconBanner" name={"checkmark"}> <a className="letterBanner">{translate("Für Geschäftskunden")}</a></Icon></td>
              <td><Icon className="iconBanner" name={"checkmark"}> <a className="letterBanner">{translate("Persönliche Beratung: 0521 - 68427")}</a></Icon></td>
              <td><Icon className="iconBanner" name={"checkmark"}> <a className="letterBanner">{translate("Merklisten & Bestellhistorien")}</a></Icon></td>
              <td><Icon className="iconBanner" name={"checkmark"}> <a className="letterBanner">{translate("Kauf auf Rechnung")}</a></Icon></td>
              <td><Icon className="iconBanner" name={"checkmark"}> <a className="letterBanner">{translate("Produkte anfragen als Gast")}</a></Icon></td>
            </tr>
          </tbody>
        </table></div></Container>*/}
        <div className="top-menu-mini absolute primary top-0 left-0 right-0 z-3" >
        {/*<div style={{background: "#000000", height: "3px"}}></div> */}
        <div className="flex flex-row justify-between items-center" >

            <SettingsMenu  attached/>
          </div>
        </div>
        
        <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState( { showMini: false } )
          }}
          onPassed={() => {
            this.setState( { showMini: "scrolled" } )
            }}>
            <div className="top-menu bg-white pa3" style={{zIndex: 100}}>
            <Container className="relative">
            <table>
              <colgroup>
              <col width="40%"/>
              <col width="20%"/>
              <col width="30%"/>
              <col width="10%"/>
              </colgroup>
              <tbody>
              <tr>
                <td>                <Image as={Link} to={"/home/"} style={{maxWidth: "300px", maxHeight: "150px"}}
              src={shop.config.logo}>

              </Image></td>
                <td className="tc">                       <SearchForm
                  style={{ width: "200px" }}
                  className={"mw6 w-100"}
                  value={searchStore.searchTerm}
                  onChange={e => {
                    searchStore.setSearchTerm( e.target.value )
                  }} icon="search" placeholder={translate( "Suche" ) + "..."}/></td>
                <td className="tr">

                {/*!shop.session && <Menu.Item className={"primary"} as={Link} to={`/login/?referrer=${document.location.pathname}`}>{translate( "Anmelden" )}</Menu.Item>*/}
                  {!shop.session &&
                  <Button as={Link} to={`/login/?referrer=${document.location.pathname}`} primary><Responsive maxWidth={1099}><Icon className="user circle tc pl1"  ></Icon></Responsive><Responsive minWidth={1100}>{translate( "Anmelden / Registrieren" )}</Responsive></Button>}
                  {/*!shop.session && <Menu.Item as={Link} to={"/customer_registration/"}>{translate( "Neukunden: Registrieren" )}</Menu.Item>*/}
                  {shop.session && shop.session.shopuser && shop.session.shopuser.guest && shop.session.shopuser.guest == true &&
                  <Button as={Link} to={`/login/?referrer=${document.location.pathname}`} primary>{translate( "Anmelden / Registrieren" )}</Button>}
                  {/*!shop.session && <Menu.Item className="buttonFade" as={Link} to={"/customer_registration/"}>{translate( "Nekunden: Registrieren" )}</Menu.Item>*/}
                  {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Fragment><CartTotalMinimum/></Fragment>}
                  <Responsive maxWidth={768}><Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon
                    name="bars"/></Menu.Item>
                  </Responsive>
                  </td>
                  <td className="tr">                    
                  <CartButton/></td>
                </tr>
              </tbody>
              </table>
            </Container>
            {/*<Container className="relative">
              <div className="absolute left-1 top-0 ">
                {/*                
                <NavLink to="/home/" className={"Logo"} >
                  <img className=""
                    src={shop.config.logo}
                    alt="zur Startseite"/>
                </NavLink> }
                <Image as={Link} to={"/home/"} style={{maxWidth: "300px", maxHeight: "150px"}}
                src={shop.config.logo}>

                </Image>
                {/*<Button basic> DE <Icon name="caret down"/></Button>}
              </div>
              
              <div className="" style={{ textAlign: "center" }}>
                       <SearchForm
                        style={{ width: "200px" }}
                        className={"mw6 w-100"}
                        value={searchStore.searchTerm}
                        onChange={e => {
                          searchStore.setSearchTerm( e.target.value )
                        }} icon="search" placeholder={translate( "Suche" ) + "..."}/>
                    </div>
              <div className="absolute right-0 top-0 mt1">
                <MenuBySlug
                  key={"mini-header"}
                  slug={"header"}
                  secondary
                  borderless>

                  {/*!shop.session && <Menu.Item className={"primary"} as={Link} to={`/login/?referrer=${document.location.pathname}`}>{translate( "Anmelden" )}</Menu.Item>}
                  {!shop.session &&
                  <Menu.Item className={"primary"}><Button as={Link} to={`/login/?referrer=${document.location.pathname}`} primary><Responsive maxWidth={1099}><Icon className="user circle tc pl1"  ></Icon></Responsive><Responsive minWidth={1100}>{translate( "Anmelden / Registrieren" )}</Responsive></Button></Menu.Item>}
                  {/*!shop.session && <Menu.Item as={Link} to={"/customer_registration/"}>{translate( "Neukunden: Registrieren" )}</Menu.Item>}
                  {shop.session && shop.session.shopuser && shop.session.shopuser.guest && shop.session.shopuser.guest == true &&
                  <Menu.Item className={"primary"}><Button as={Link} to={`/login/?referrer=${document.location.pathname}`} primary>{translate( "Anmelden / Registrieren" )}</Button></Menu.Item>}
                  {/*!shop.session && <Menu.Item className="buttonFade" as={Link} to={"/customer_registration/"}>{translate( "Nekunden: Registrieren" )}</Menu.Item>}
                  {<Menu.Item>
                    {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Fragment><CartTotalMinimum/></Fragment>}
                    <CartButton/>
                    </Menu.Item>}
                  
                  <Responsive maxWidth={768}><Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon
                    name="bars"/></Menu.Item>
                  </Responsive>
                </MenuBySlug>
                {/*{!shop.session && <div><Link to="/login">Anmelden</Link> oder <Link to="/customer_registration">Registrieren</Link></div>}}
              </div>
              
              <div className="tc pb3">
                <div className="logo--shop block">
                </div>
              </div>
              {/*<Menu slug="menu-en"/>}
            </Container>*/}
          </div>
        </OnOffset>
        {/*<MenuUtility list={list}/>*/}
        <div className="TopBotMenufrankenstolz"></div>
        <MegaMenuBig/>
        <div className="TopBotMenufrankenstolz"></div>
      </div>
    )
  }
}

const MiniHeaderMobile = () => <div
  className="mini-header z-8 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
      <div className="MobileHeader ">
        <div className="pa1 ph2 ph2-ns pt3-ns pb3-ns">
          <div className="flex flex-row justify-between items-center ">
            <div className={"w-70 flex flex-row justify-start pr4 pb3 pt3"}>
              <Button className="ButtonFooter" as="a"><Icon className="IconCss" onClick={app.sidebarLeft.toggle.dispatch} name="big bars" /></Button>
              {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
              <Button className="ButtonFooter" as={Link} to={`/account/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big user circle" /></Button>}
              {((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
              <Button className="ButtonFooter" as={Link} to={`/login/?referrer=${document.location.pathname}`}><Icon className="IconCss"  name="big user circle" /></Button>}
            </div>
            
            <div className={"w-100 flex flex-row items-center justify-center"}>
              <Image as={Link} to={"/home/"} src={shop.config.logo} />
            </div>
            
            <div className={"w-70 flex flex-row justify-end items-center pr4 pb3 pt3"}>
              {/*<Search />*/}
              <Button className="ButtonFooter" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              <Button className="ButtonFooter" as={Link} to={`/checkout/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big shopping cart" /></Button>
            </div>
          </div>
        </div>
      </div>
</div>


const MiniHeader = () => <div className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
  <div className="ph2">
    <MenuBySlug slug={"header"}
                key={"mini-header-main"}
                secondary
                borderless>
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest ?  <Fragment><Menu.Item
        position="right"
        content={translate( "Orderlist" )}
        as={Link}
        to="/orderlist/"/>
        <Menu.Item 
        as={Link}
        to="/search/"><Icon name="search"/></Menu.Item></Fragment> :
      <Fragment><Menu.Item position="right"
        as={Link}
        to="/search/"><Icon name="search"/></Menu.Item></Fragment>} 
      {shop.session && <Menu.Item><CartButton/></Menu.Item>}
    </MenuBySlug>
  </div>
</div>


class OnOffset extends Component {
  
  state = {
    passed: false
  }
  
  componentDidMount() {
    window.addEventListener( "scroll", this.handleScroll )
    this.handleScroll()
  }
  
  componentWillUnmount() {
    window.removeEventListener( "scroll", this.handleScroll )
  }
  
  handleScroll = () => {
    let { passed } = this.state
    let { pageYOffset } = window
    if ( pageYOffset > this.props.offset ) {
      if ( !passed ) {
        this.setState( { passed: true } )
        this.props.onPassed && this.props.onPassed()
      }
    } else {
      if ( passed ) {
        this.setState( { passed: false } )
        this.props.onPassedReverse && this.props.onPassedReverse()
      }
    }
  }
  
  render() {
    return this.props.children || null
  }
}


@observer
class MegaMenu extends Component {
  
  state = {
    hover: false,
    index: false
  }
  
  onLeave = () => {
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 200 )
  }
  
  onHover = ( { index } ) => {
    this.setState( { index, hover: true } )
  }
  
  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const category = shop.categoriesById.get( index )
    
    return <div className="MegaMenu bg-blue relative" style={{ zIndex: 98 }}>
      <Container className="">
        <div className="pb2">
          {categories.length > 0 && <div>
            <Menu inverted attached="bottom" fluid stackable secondary widths={categories.length}>
              {categories.map( category => {
                
                                 if ( category.children.length === 0 ) {
                                   return <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}>{category.title}</Menu.Item>
                                 }
                
                                 return <Dropdown key={category.map_id} item text={category.title}>
                                   <Dropdown.Menu>
                                     <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}><b>{category.title}</b></Menu.Item>
                                     {category.children.map( category => {
                                       return <Dropdown.Item as={Link} to={`/collection/${category.map_id}/`}
                                                             key={category.map_id}>{category.title}</Dropdown.Item>
                                     } )}
                                   </Dropdown.Menu>
                                 </Dropdown>
                               }
              )}
            </Menu>
          
          </div>
          }
        
        
        </div>
      
      </Container>
    </div>
  }
}


let isHovering = false

@observer
@withRouter
export class MegaMenuBig extends Component {
  
  state = {
    hover: false,
    index: false,
  }
  
  onLeave = () => {
    isHovering = false
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 120 )
  }
  
  onHover = ( { index } ) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout( () => {
      if ( isHovering ) this.setState( { index, hover: true } )
    }, DELAY )
  }
  
  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const selectedCategory = shop.categoriesById.get( index )
    return <div
      onMouseLeave={this.onLeave}
      
      className="TopMenuOrtho bg-dark relative" style={{color: "#1f6056;", zIndex: 99 }}>
      <Container className="">
        <div className="TopMenuOrtho"></div>
        <div className="">
          {/*categories.length > 0 &&
            <div className={"flex flex-row f5 justify-start items-center flex-wrap space-around"}>
              {categories
                .map( category => {
                  // console.log( document.location.pathname, `/collection/${category.map_id}/` )
                  const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` ) || selectedCategory && selectedCategory.map_id === category.map_id
                  console.log("category.children",category.children)
                  return <Link key={category.map_id}
                               onClick={() => {
                                 this.setState( { index: false, hover: false } )
                               }}
                               className={` db pv3 pl2 pr2 f5 white nowrap fw5 hover-black space-around  ${active ? "active" : ""}`}
                               onMouseEnter={( e ) => this.onHover( { index: category.map_id } )}
                               to={`/collection/${category.map_id}/`}><span className="dib pr2 f6">{category.title}
											 </span>
                  </Link>
                } )
              }</div>*/
              
          }
          {categories.length > 0 &&
            <div className={"flex flex-row f5 justify-start items-center flex-wrap space-around"}>
              {categories
                .map( category => {
                  // console.log( document.location.pathname, `/collection/${category.map_id}/` )
                  const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` ) || selectedCategory && selectedCategory.map_id === category.map_id
                  //console.log("category.children",category.children)
                    return (
                      <Fragment key={category.map_id}>
                      <Link
                        key={category.map_id}
                        onClick={() => {
                        this.setState({ index: false, hover: false });
                        }}
                        className={`db pv3 f2 white nowrap fw5 hover-black flex-grow-1 ${active ? "active" : ""}`}
                        onMouseEnter={(e) => {
                        this.onHover({ index: category.map_id });

                        }}
                        style={{pointerEvents: this.state.disableHover ? 'none' : 'auto' }}
                        to={`/collection/${category.map_id}/`}
                      >
                        <span className="dib pr2 f6">{category.title}</span>
                      </Link>
                      {selectedCategory && (<Container
                                              style={{
                                                marginTop: "0",
                                                backgroundColor: "#5c7eb1",
                                                alignContent: "center",
                                                position: "absolute",
                                                top: "100%",
                                              }}
                                              onMouseLeave={this.onLeave}
                                              className="bg-white animate fadeIn variantsContainer flex-grow-1 megaMenuStyle" >
                        <div 

                        >
                        <div>
                          <div className="flex flex-row justify-between bg-black-10">
                          <Link
                            className={"db pa3 f6 ph4 white nowrap fw4 hover-primary b f6"}
                            onClick={this.onLeave}
                            to={`/collection/${selectedCategory.map_id}/`}
                          >
                            {selectedCategory.title} <Icon name={"chevron right"} />
                          </Link>
                          <Button
                            className={"white pointer pa3 icon-button"}
                            onClick={this.onLeave}
                            icon={"times"}
                          />
                          </div>
                          <div className="pa4-ns pa3 pb4">
                          <div className="flex flex-row flex-wrap ">
                            {selectedCategory.children.map((subCategory) => {
                            const active = document.location.pathname.startsWith(
                              `/collection/${selectedCategory.map_id}/${subCategory.map_id}/`
                            );
                            return (
                              <div className="pr3 pb4 " key={subCategory.map_id} style={{ flexBasis: "25%" }}>
                              {/*LEVEL II*/}
                              <Link
                              onClick={() => {
                              this.setState({ index: false, hover: false });
                              }}
                              className={`db f5 pv2 pb3 flex-grow-1 b white nowrap fw5 hover-primary ${
                              active ? "active" : ""
                              }`}
                              to={`/collection/${selectedCategory.map_id}/${subCategory.map_id}/`}
                              >
                              <b>
                              {subCategory.title}
                              {/*<span className="red">({subCategory.sort})</span>*/}
                              </b>
                              </Link>
                              {/*LEVEL III*/}
                              {subCategory.children.map((c) => (
                              <Fragment key={c.map_id}>
                              <Link
                                key={c.map_id}
                                onClick={() => {
                                this.setState({ index: false, hover: false });
                                }}
                                className={`db f5 pv1 pb2 pr4 white-80 nowrap fw4 hover-primary ${
                                active ? "active" : ""
                                }`}
                                to={`/collection/${selectedCategory.map_id}/${c.map_id}/`}
                              >
                                {c.title}
                                {/*<span className="red">({c.sort})</span>*/}
                              </Link>
                              {/*LEVEL IV*/}
                              {c.children.map((d) => (
                                <Link
                                key={d.map_id}
                                onClick={() => {
                                this.setState({ index: false, hover: false });
                                }}
                                className={`db f6 pv1 pl3 pb2 pr4 white-80 nowrap fw4 hover-primary ${
                                active ? "active" : ""
                                }`}
                                to={`/collection/${selectedCategory.map_id}/${c.map_id}/${d.map_id}/`}
                                >
                                {d.title}
                                {/*<span className="red">({d.sort})</span>*/}
                                </Link>
                              ))}
                              </Fragment>
                              ))}
                              </div>
                            );
                            })}
                          </div>
                          </div>
                        </div>
                        </div></Container>
                      )}
                      </Fragment>
                    );
                } )
              }</div>
              
          }
             <div className="BotMenuOrtho"></div>         
        </div>

      </Container>
    </div>
  }
}





// WEBPACK FOOTER //
// ./src/theme/hvz/components/Header/Header.js